import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ProductoEditComponent } from '../producto-edit/producto-edit.component';

@Component({
  selector: 'app-producto',
  templateUrl: './producto.component.html',
  styleUrls: ['./producto.component.css'],
  providers:[
    { provide: MatDialogRef,useValue: {} }
  ]
})
export class ProductoComponent implements OnInit {
  errMsg:any;
  roles:any=[];
  prods:any=[];
  prods2:any=[];
  descs:any=[];
  
  constructor(private dataService: DataService, public dialogRef: MatDialogRef<ProductoEditComponent>, public dialog: MatDialog) { }

  ngOnInit() {    
    this.dataService.getRoles().subscribe(
                      rows => {   
                              this.roles = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnRolesCargados());
  }

  fnActivos(ev){
    //console.log(ev);
    this.prods2=[];
    if(ev.target.checked){
      //--> Solo activos
      for(var i = 0; i < this.prods.length; i++){
        if(this.prods[i].act==1){
          this.prods2.push(this.prods[i]);
        }
      }
    }
    else{
      //-->Todos
      for(var i = 0; i < this.prods.length; i++){
        this.prods2.push(this.prods[i])
      }
    }
  }

  fnRolesCargados(){
    //console.log(this.roles);
    this.dataService.getDescuentos(-1).subscribe(
                      rows => {   
                              this.descs = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnDescuentosCargados());
  }

  fnDescuentosCargados(){
    //console.log(this.descs);
    this.dataService.getProductos().subscribe(
                      rows => {   
                              this.prods = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnProductosCargados());
}

  fnProductosCargados(){
    //console.log(this.prods);
    var aux = [];
    var auxDes = [];
    for (var i = 0; i < this.prods.length; i++){
      if(this.prods[i].roles)
        aux = this.prods[i].roles.split(',');
      else 
        aux = [];
      if(this.prods[i].descuentos)
        auxDes = this.prods[i].descuentos.split(',');
      else
        auxDes = [];
      this.prods[i].rol = [];
      this.prods[i].desc = [];
      var auxRol;
      var auxDesc;
      for(var j = 0; j < aux.length; j++){
        auxRol = this.dataService.findItemInObject(this.roles, aux[j], "idRol");
        this.prods[i].rol.push({'id': aux[j], 'rol':auxRol.rol, 'descrip':auxRol.descrip, 'act': auxRol.act})
      }
      for(var k = 0; k < auxDes.length; k++){
        auxDesc = this.dataService.findItemInObject(this.descs, auxDes[k], "id");
        this.prods[i].desc.push({'id': auxDes[k], 'desc':auxDesc.descuento, 'descrip':auxDesc.descrip, 'act':auxDesc.act})
      }
    }
    this.prods2=this.prods;
  }

  fnEditar(prod){
    //console.log("Editar: " + prod.id)
    let dialogRef = this.dialog.open(ProductoEditComponent, {
                                      width: "600px",
                                      data: { 
                                            id:prod.id,
                                            item:prod,
                                            descs:this.descs,
                                            roles:this.roles
                                            }
                                    });
    dialogRef.afterClosed().subscribe(result => {
                                    //console.log("Popup cerrado");
                                    this.fnDescuentosCargados();
                                    }); 
  }

  fnNuevo(){
    //console.log("Ingresar nuevo item");
    let dialogRef = this.dialog.open(ProductoEditComponent, {
                                      width: "600px",
                                      data: { 
                                            id:-1,
                                            item: {'act':1,
                                                   'cat': null,
                                                   'categoria': null, 
                                                   'relExp': null,
                                                   'descrip': null,
                                                   'fecIni': null,
                                                   'fecRel': null,
                                                   'idProd': null,
                                                   'idGpo': null,
                                                   'incIVA': 'NO',
                                                   'incOTRO': 'NO',
                                                   'prod': null,
                                                   'proxPrecio': null,
                                                   'subTot': null,
                                                   'rol':[{'id':10, 'rol':'Jefe T aquilla', 'descrip':null, 'act':1}],
                                                   'desc':[{'id':1, 'desc':'Cortesía', 'descrip':null, 'act':1}]
                                                  },
                                            descs:this.descs,
                                            roles:this.roles    
                                            }
                                    });
    dialogRef.afterClosed().subscribe(result => {
                                    //console.log("Popup cerrado");
                                    this.fnDescuentosCargados();
                                    }); 
  }

}
